import React from 'react';
import PropTypes from 'prop-types';

import {Paper, Skeleton} from 'views/components';

const PanelSkeleton = (props) => {
  const {
    height = 300,
  } = props;

  return (
    <Paper
      sx={{
        p: 3,
        borderRadius: '12px',
        border: '1px solid #E5E5E5',
        boxShadow: 'none',
      }}
    >
      <Skeleton variant='text' width='30%' height={24} />
      <Skeleton variant='text' width='45%' height={18} />
      <Skeleton variant='rounded' width='100%' height={height} sx={{mt: 2}} />
    </Paper>
  );
};

PanelSkeleton.propTypes = {
  height: PropTypes.number,
};

export default React.memo(PanelSkeleton);
